import Masonry from 'masonry-layout';

[ ...document.querySelectorAll('.masonry') ].forEach( el => {
    new Masonry( el, { 
        itemSelector: '.masonry-item',
        percentPosition: true,
        transitionDuration: 0
    });
})